import { spacing } from 'ext-ui/style/spacing'
import React from 'react'
import ManagerReviewIconCell from 'src/components/MangerReviewIconCell/MangerReviewIconCell'
import ReceiptAgentStatusCell from 'src/components/TransactionsDataGrid/cells/ReceiptAgentStatusCell'
import {
  ReceiptRecoveryLifecycleState,
  TransactionManagerRejectionReason,
  TransactionManagerReviewStatus,
} from 'src/models/transaction.models'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing(4)};
  height: ${spacing(8)};
`

const ReceiptSlot = styled.div`
  display: flex;
  width: ${spacing(8)};
  height: ${spacing(8)};
  flex: 0 0 ${spacing(8)};
  align-items: center;
  justify-content: center;
`

const StatusSlot = styled.div`
  display: flex;
  width: ${spacing(4)};
  height: ${spacing(4)};
  flex: 0 0 ${spacing(4)};
  align-items: center;
  justify-content: center;
`

interface PolicyStatusCellProps {
  receipt?: React.ReactNode
  receiptAgentStatus?: ReceiptRecoveryLifecycleState
  managerReviewStatus?: TransactionManagerReviewStatus
  managerRejectionReason?: TransactionManagerRejectionReason
  hasManagerReview?: boolean
  showManagerReview?: boolean
}

export default function PolicyStatusCell({
  receipt,
  receiptAgentStatus,
  managerReviewStatus,
  managerRejectionReason,
  hasManagerReview = false,
  showManagerReview = false,
}: PolicyStatusCellProps): React.ReactElement {
  return (
    <Container data-testid="policy-status-cell">
      <ReceiptSlot data-testid="policy-status-receipt">{receipt}</ReceiptSlot>
      <StatusSlot data-testid="policy-status-receipt-agent">
        <ReceiptAgentStatusCell status={receiptAgentStatus} variant="icon" />
      </StatusSlot>
      {showManagerReview && (
        <StatusSlot data-testid="policy-status-manager-review">
          {hasManagerReview && (
            <ManagerReviewIconCell
              compact
              status={managerReviewStatus}
              rejectionReason={managerRejectionReason}
            />
          )}
        </StatusSlot>
      )}
    </Container>
  )
}
